// Jest with JSDOM doesn't allow to override some win props, e.g. win.top, win.parent
// To be able to test different scenarios (multiple frames on the page, current frame is not top) need to proxy
// win object via this module, so it'll possible to mock it in test environment
export const win: Window = typeof window !== 'undefined' ? window : undefined;
